import { ClaimValue } from 'api/endpoints/settlements';
import classnames from 'classnames';
import { Cell, ClaimsDocumentsTable, Row } from 'components/ClaimsDocumentsTable';
import { formatMoney } from 'utils/formatNumber';
import './SettlementAmountGrid.css';

interface Props {
  claims: ClaimValue[] | undefined;
  total: ClaimValue | undefined;
}

export const SettlementAmountGrid = ({ claims, total }: Props) => {
  return (
    //todo: create a new table instead of ClaimsDocumentsTable (or no??????)
    <ClaimsDocumentsTable
      className="settlement-amount-grid"
      // emptyListMessage={<span>No attachments for this Settlement</span>}
      headerItems={[
        'Claim number / Debtor Name',
        'Amounts',
        'Secured',
        'Admin',
        'Priority',
        'Unsecured',
        'Total',
      ]}
    >
      <ClaimsDocumentsRows claims={claims} total={total} />
    </ClaimsDocumentsTable>
  );
};

const EMPTY_CLAIM: ClaimValue = {} as ClaimValue;

const ClaimsDocumentsRows = (props: Pick<Props, 'claims' | 'total'>) => {
  const { claims, total } = props;

  if (!claims) return <ValueRow key={0} claim={EMPTY_CLAIM} />;

  return (
    <>
      {claims.map((r) => (
        <ValueRow key={r.claimId} claim={r} />
      ))}
      <ValueRow key="total_row" claim={total} useTotalRowStyle />
    </>
  );
};

const ValueRow = (props: {
  claim: ClaimValue | undefined;
  useTotalRowStyle?: boolean;
}) => {
  const { claim, useTotalRowStyle } = props;

  const rowClassName = classnames('settlement-amount-grid__row', {
    'settlement-total-row': useTotalRowStyle,
  });

  if (!claim) return <Row className={rowClassName}></Row>;

  return (
    <Row className={rowClassName}>
      <Cell style={{ width: '25%' }}>{claim.name}</Cell>

      <CellDoubleValue value1="Current:" value2="Proposed:" />
      <CellDoubleValue
        rightAligned
        value1={formatMoney(claim.currentSecured)}
        value2={formatMoney(claim.proposedSecured)}
      />
      <CellDoubleValue
        rightAligned
        value1={formatMoney(claim.currentAdministrative)}
        value2={formatMoney(claim.proposedAdministrative)}
      />
      <CellDoubleValue
        rightAligned
        value1={formatMoney(claim.currentPriority)}
        value2={formatMoney(claim.proposedPriority)}
      />
      <CellDoubleValue
        rightAligned
        value1={formatMoney(claim.currentUnsecured)}
        value2={formatMoney(claim.proposedUnsecured)}
      />
      <CellDoubleValue
        rightAligned
        value1={formatMoney(claim.currentTotal)}
        value2={formatMoney(claim.proposedTotal)}
      />
    </Row>
  );
};

const CellDoubleValue = (props: {
  value1: string | number;
  value2: string | number;
  rightAligned?: boolean;
}) => {
  return (
    <Cell>
      <div
        className={classnames('settlement-amount-grid__cell-double-value', {
          'settlement-amount-grid__cell-right-aligned': props.rightAligned,
        })}
      >
        <span> {props.value1} </span>
        <span> {props.value2} </span>
      </div>
    </Cell>
  );
};
